export default {
  common: {
    edited: 'Edited',
    error: {
      general: 'Oops!',
      failedToOpenMaps: 'Failed to open maps',
      failedToOpenLink: 'Failed to open the link. No web browser is available on this device.',
      reportTooMany: "You've sent a lot of reports recently. Please wait a bit and try again.",
      reportFailed: "We couldn't open the report form. Please try again.",
      reportUnavailable: 'This content is no longer available to report.',
      popupBlocked:
        'Your browser blocked the form from opening. Allow pop-ups for this site and try again.',
      ipBlocked:
        'Your IP address has been blocked due to suspicious activity. If you believe this is a mistake, please contact support.',
      crashTitle: 'Oops! Something went wrong',
      crashSubtitle: "We've been notified and are looking into it.",
      crashReload: 'Reload',
      crashRetry: 'Try Again',
    },
    updateBanner: {
      message: "We've made some improvements",
      refresh: 'Reload',
    },
    connection: {
      offline: 'No internet connection',
      connecting: 'Connecting...',
    },
    success: 'Success!',
    follow: 'Follow',
    unfollow: 'Unfollow',
    followed: 'Following',
    message: 'Message',
    empty: 'Nothing to see here yet',
    post: 'post',
    comment: 'comment',
    photo: 'photo',
    month: 'month',
    year: 'year',
    cancel: 'Cancel',
    continue: 'Continue',
    back: 'Back',
    close: 'Close',
    delete: 'Delete',
    update: 'Update',
    saveChanges: 'Save Changes',
    scrollToTop: 'Scroll to top',
    undo: 'Undo',
    report: 'Report',
    openingForm: 'Opening the form...',
    accept: 'Accept',
    reject: 'Reject',
    retry: 'Retry',
    send: 'Send',
    unblock: 'Unblock',
    comingSoon: 'Coming soon',
    loading: 'Loading...',
    done: 'Done',
    clear: 'Clear',
    clearAll: 'Reset',
    search: 'Search...',
    share: {
      success: 'Shared successfully',
      error: 'Failed to share',
      copied: 'Link copied to clipboard',
      shareLink: 'Share link',
      url: 'URL',
      copy: 'Copy',
      open: 'Open',
    },
    validation: {
      min: 'Must be at least {{minLength}} characters',
      max: 'Must be at most {{maxLength}} characters',
      required: 'This field is required',
      requiredField: '{{field}} is required',
    },
    filters: {
      myType: 'my type',
      all: 'filters',
    },
    relativeTime: {
      now: 'now',
      justNow: 'just now',
    },
  },
  myTypeFilter: {
    title: 'My Type Filter',
    enableOption: 'Turn On',
    disableOption: 'Turn Off',
    statusEnabled: 'On',
    statusDisabled: 'Off',
    configure: 'Configure…',
    configureTitle: 'Configure My Type Filter',
    enabled: 'My Type filter enabled',
    disabled: 'My Type filter disabled',
    enableError: 'Failed to enable filter',
    disableError: 'Failed to disable filter',
    infoTitle: 'What is My Type Filter?',
    infoDescription:
      'Set your preferences once and the feeds, members, and photos lists will automatically show only people who match your criteria. You can enable or disable this filter at any time.',
    preview: 'Preview',
    apply: 'Apply',
    appliedSuccess: 'Filter settings saved',
    appliedError: 'Failed to save filter settings',
    filteredOutPercent: '{{percent}}% of members filtered out',
    filterWarning: 'Filtering out too many people might impact your experience.',
  },
  sensitiveContent: {
    title: 'Sensitive Content',
    statusHidden: 'Hidden',
    statusVisible: 'Visible',
    configure: 'Configure...',
  },
  navigation: {
    feeds: 'Feeds',
    people: 'Members',
    photo: 'Photo',
    photos: 'Photos',
    events: 'Events',
    discover: 'Discover',
  },
  communities: {
    myCommunities: 'My Communities',
    menu: {
      remove: 'Remove from My Communities',
    },
    delete: {
      confirmTitle: 'Remove Community',
      confirmMessage:
        'Are you sure you want to remove {{communityName}} from My Communities? You can sign in again later.',
      success: 'Community removed',
      error: 'Failed to remove community',
    },
    visitSite: 'Visit {{communityName}}',
  },
  auth: {
    createAccount: 'Create account',
    signIn: {
      title: 'Sign In',
      welcomeBack: 'Welcome back!',
      heading: 'Sign in to {{communityName}}',
      usernameLabel: 'Username',
      usernamePlaceholder: 'Enter username',
      usernameNotFound: 'Username not found',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter password',
      passwordIncorrect: 'Incorrect password or username',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot Password?',
      submit: 'Log in',
      submitting: 'Signing in...',
      noAccount: "Don't have an account?",
      signUp: 'Sign up',
      loginFailedToast: 'Login failed',
      removeCredentialsError: 'Failed to remove credentials',
      unexpectedError: 'An unexpected error occurred',
    },
    signUp: {
      redirectHelper:
        'You will be redirected to our legacy {{communityName}} website to create an account. Once you have created an account, you can return to this app to sign in.',
      successToast: "Account created. We've emailed you your password.",
    },
    forgotPassword: {
      title: 'Forgot Password',
      redirectHelper:
        'You will be redirected to our legacy {{communityName}} website to reset your password. After you receive your new password by email, return to the app to sign in.',
      successToast: "We've emailed you a new password.",
    },
  },
  feeds: {
    global: 'Global Feed',
    global_short: 'Global',
    local: 'Local Feed',
    local_short: 'Local',
    network: 'Following Feed',
    network_short: 'Following',
    search: 'Search',
    search_short: 'Search',
    search_placeholder: 'Search posts',
    empty: 'Sorry, this came up empty',
    latestSearches: 'Recent Searches',
    popularSearches: 'Popular Searches',
    popularHashtags: 'Popular Hashtags',
    onlineMembers: 'Online Now',
    profileVisitors: 'Visited My Profile',
    searchMembersHint: 'Looking for someone?',
    searchMembersLink: 'Search members',
    pinned: 'Set as default feed',
    unpinned: 'Global feed restored as default',
    alreadyDefault: 'This is already your default feed. Switch to another feed to change it.',
    radius: {
      title: 'Radius',
      km: 'km',
      mi: 'mi',
    },
  },
  messages: {
    title: 'Messages',
    inbox: 'Inbox',
    inboxBadgeUnreadCaption_one: 'unread',
    inboxBadgeUnreadCaption_other: 'unread',
    inboxBadgeMessagesCaption_one: 'message',
    inboxBadgeMessagesCaption_other: 'messages',
    unread: 'Unread',
    online: 'Online',
    deleted: 'Deleted',
    emptyDeleted: 'No deleted conversations in the last 90 days',
    search: 'Search',
    search_placeholder: 'Enter a username',
    empty: 'No messages to show',
    conversation: 'Conversation',
    emptyConversation: 'No conversation items to show',
    typeMessage: 'Type a message...',
    photoMessage: 'sent a photo',
    gifMessage: 'sent a GIF',
    stickerMessage: 'sent a sticker',
    clipMessage: 'sent a clip',
    youSentPhoto: 'You sent a photo',
    youSentGif: 'You sent a GIF',
    youSentSticker: 'You sent a sticker',
    youSentClip: 'You sent a clip',
    replyFailed: 'Failed to send reply',
    compose: {
      messageToUser: 'Message to {{userName}}',
      enterMessage: 'Enter your message...',
    },
    errors: {
      failedToLoad: 'Failed to load conversation',
      failedToSend: 'Failed to send message',
    },
    success: {
      messageSent: 'Message sent successfully',
    },
    loadOlderMessages: 'Load older messages',
    loadingOlderMessages: 'Loading older messages...',
    loadingNewerMessages: 'Loading newer messages...',
    markAsRead: {
      error: 'Failed to mark message as read',
    },
    markAsUnread: {
      error: 'Failed to mark message as unread',
    },
    delete: {
      success: 'Message deleted successfully',
      error: 'Failed to delete message',
    },
    undelete: {
      success: 'Message restored successfully',
      error: 'Failed to restore message',
    },
    menu: {
      markRead: 'Mark as read',
      markUnread: 'Mark as unread',
      viewProfile: 'View profile',
      deleteConversation: 'Delete conversation',
      restoreConversation: 'Restore conversation',
      reportConversation: 'Report conversation',
    },
    copy: {
      success: 'Content copied to clipboard',
      error: 'Failed to copy content',
      noContent: 'No content to copy',
    },
    download: {
      label: 'Save photo',
      success: 'Photo saved to your library',
      error: 'Failed to save photo',
      permissionDenied: 'Photo library permission is required to save photos',
    },
    unreadMessage: 'Unread message',
    uploadPhoto: 'Upload Image',
    dropImageToSend: 'Drop image to send',
    dropImageToSendToUser: 'Drop image to send to {{userName}}',
    sendPhoto: 'Send Photo',
    photoUploadFailed: 'Image upload failed',
    photoUploadSuccess: 'Image uploaded successfully',
    selectPhoto: 'Photos',
    takePhoto: 'Camera',
    cancel: 'Cancel',
    confirm: 'Confirm',
    cameraPermissionNotGranted: 'Camera permission not granted',
    mediaLibraryPermissionNotGranted: 'Media library permission not granted',
    failedToPickImage: 'Failed to pick image',
    imageTooLarge: 'Image is too large. Maximum size is {{size}}MB.',
    adminClosedInfo:
      'This conversation is closed. For any follow-up, open a support ticket and include relevant details.',
    contactSupport: 'Contact Support',
    newAccountNotice: {
      title: '{{name}} joined recently',
      body: 'Take your time getting to know new members. Be careful sharing personal info, and be wary if they ask to move the chat to Telegram, WhatsApp, text or any other messaging service.',
    },
  },
  people: {
    nearby: 'Members Nearby',
    nearby_short: 'Nearby',
    online: 'Members Online',
    online_short: 'Online',
    birthdays: 'Birthdays',
    birthdays_short: 'Birthdays',
    new: 'New Members',
    new_short: 'New Members',
    following: "Members I'm Following",
    following_short: 'Following',
    followers: 'My Followers',
    followers_short: 'Followers',
    visitors: 'My Visitors',
    visitors_short: 'Visitors',
    search: 'Member Search',
    search_short: 'Search',
    empty: 'Sorry, this came up empty',
    displayModeCompact: 'Compact view',
    displayModeRegular: 'Regular view',
    nearbyFilter: {
      online: 'Online',
      recent: 'Recent',
      active: 'Last 90 days',
      newmembers: 'New',
      all: 'All',
    },
  },
  search: {
    username: 'Username',
    usernamePlaceholder: 'Search by username',
    location: 'Location',
    nearMe: 'Near me',
    anywhere: 'Anywhere',
    customLocation: 'Custom location',
    ranges: 'Ranges',
    age: 'Age',
    bmi: 'BMI',
    filters: 'Filters',
    additional: 'Additional Filters',
    hasPhotos: 'Has photos',
    hasPrivatePhotos: 'Has private photos',
    isOnline: 'Currently online',
    isActive: 'Active in last 90 days',
    isNew: 'New member',
    isFollower: 'Follows me',
    imFollowing: 'Following',
    imTheirBodyType: 'Interested in my body type',
    clearAll: 'Reset',
    search: 'Search',
    anything: 'Anything',
    to: 'to',
    andUnder: 'and under',
    andAbove: 'and above',
    multipleSelected: '{{count}} selected',
    selectedCount: '{{count}} selected',
    noneSelected: 'None selected',
    selectAtLeastOneFilter: 'Please select at least one filter to start your search',
    restoredFiltersTitle: 'Filters restored',
    restoredFiltersDescription:
      'Your search filters from your last search have been restored. Want to start fresh? Click the reset button below.',
  },
  discover: {
    seeMore: 'See more',
    tabBarHintLead: 'Your tabs have a secret menu',
    tabBarHintBody: 'Press and hold, swipe, and jump to any list in one move.',
    sectionSubtitles: {
      photos: {
        latest: 'Public photos from the community',
        network: 'Public photos from members you follow',
        private: 'Private photos from members who let you in',
        favorites: "Photos you've liked",
      },
      events: {
        upcoming: 'All upcoming community events',
        nearby: 'Upcoming events within {{distance}}',
        network: 'Events attended by members you follow',
        past: 'Archived community events',
      },
    },
  },
  photos: {
    photoOf: 'Photo of {{userName}}',
    posted: 'Posted',
    latest: 'Latest Photos (Everyone)',
    latest_short: 'Latest',
    network: 'Latest Photos (Following)',
    network_short: 'Following',
    private: 'Latest Photos (Private)',
    private_short: 'Private',
    favorites: 'Favorite Photos',
    favorites_short: 'Favorites',
    addPublicPhoto: 'Add a Public Photo',
    addPrivatePhoto: 'Add a Private Photo',
    dropToUploadPublic: 'Drop to upload to Public',
    dropToUploadPrivate: 'Drop to upload to Private',
    captionPlaceholder: 'Add a caption (optional)',
    uploadSuccess: 'Photo uploaded',
    uploadFailed: 'Failed to upload photo',
    uploadingImage: 'Uploading image...',
    policyLink: 'Read our photo policy',
    artworkNotice: 'AI-generated images must be captioned as such and posted sparingly.',
    artworkNoticeFerzu: 'Artwork must be credited. AI-generated images are not allowed.',
    empty: 'No photos to show',
    sensitiveReminder: {
      title: 'Sensitive and unreviewed photos are hidden',
      body: 'Your safety settings hide sensitive and unreviewed photos. You can change this anytime in Filters or Settings.',
      action: 'Review safety options',
      dismiss: 'Dismiss',
    },
  },
  photo: {
    menu: {
      editCaption: 'Edit caption',
      useAsProfilePhoto: 'Use as profile photo',
      moveToPrivate: 'Move to private folder',
      requestReview: 'Request a review',
      report: 'Report photo',
      delete: 'Delete photo',
    },
    caption: {
      placeholder: 'Add a caption (optional)',
      updateSuccess: 'Caption updated',
      updateError: 'Failed to update caption',
    },
    profile: {
      confirmTitle: 'Use as Profile Photo',
      confirmMessage: 'Are you sure you want to use this as your profile photo?',
      setSuccess: 'Profile photo updated',
      setError: 'Failed to update profile photo',
    },
    private: {
      success: 'Photo moved to private folder',
      error: 'Failed to move photo to private folder',
    },
    locked: {
      message:
        'Upgrade your account to {{premiumPlan}} to view unlimited photos in lists and full screen.',
    },
    review: {
      requestSuccess: 'Review requested',
      requestError: 'Failed to request review',
      dialogTitle: 'Photo rating',
      dialogIntro:
        'If you think our AI-based rating system or human reviewers made a mistake in determining your photo rating or you want to move a photo from your Private folder to Public, you can request a manual review to have the photo rated again. Please keep in mind that each photo can only be reviewed once and the process can take a few hours.',
      possibleRatingsTitle: 'Possible ratings are:',
    },
    delete: {
      confirmTitle: 'Delete Photo',
      confirmMessage: 'Are you sure you want to delete this photo? This action cannot be undone.',
      success: 'Photo deleted successfully',
      error: 'Failed to delete photo',
    },
  },
  events: {
    upcoming: 'Upcoming Events',
    upcoming_short: 'Upcoming',
    nearby: 'Nearby Events',
    nearby_short: 'Nearby',
    network: 'Network Events',
    network_short: 'Network',
    attending: 'Attending',
    attend: 'Attend',
    unattend: 'Not attending',
    follow: 'Follow',
    following: 'Following',
    attendees_one: 'attendee',
    attendees_other: 'attendees',
    attendees_short: 'Attendees',
    followers_one: 'follower',
    followers_other: 'followers',
    followers_short: 'Followers',
    past: 'Past Events',
    past_short: 'Past',
    organizer: 'Organizer',
    curator: 'Curator',
    curatorNotice:
      'This person helps maintain event listings. Please report any inaccuracies you may spot. If you are the event organizer, you can take ownership of this page by contacting {{communityName}}.',
    date_time: 'Date & time',
    location: 'Location',
    website: 'Website',
    empty: 'No events to show',
    noEventsForMember: 'No events yet',
    attendeesCount_one: '{{count}} attendee',
    attendeesCount_other: '{{count}} attendees',
    attendSuccess: 'You are attending this event',
    unattendSuccess: 'You are no longer attending this event',
    attendError: 'Failed to mark attendance',
    unattendError: 'Failed to remove attendance',
    followError: 'Failed to follow event',
    unfollowError: 'Failed to unfollow event',
    createSuccess: 'Event created',
    updateSuccess: 'Event updated',
    createError: 'Failed to create event',
    updateError: 'Failed to update event',
    deleteSuccess: 'Event deleted',
    deleteError: 'Failed to delete event',
    deleteEvent: 'Delete Event',
    deleteConfirmTitle: 'Delete Event?',
    deleteConfirmMessage:
      'Are you sure you want to delete this event? This action cannot be undone.',
    createEvent: 'New Event',
    editEvent: 'Edit Event',
    form: {
      code: 'Event Code',
      codePlaceholder: 'e.g. my-event-2026',
      codeHint: 'Letters, numbers, hyphens and underscores. Cannot start with a number.',
      name: 'Event Name',
      namePlaceholder: 'Enter event name',
      nameHint:
        'Try not to include the date or month in the event name. If you need to, add it at the end of the name.',
      startDate: 'Start Date',
      endDate: 'End Date (optional)',
      selectDate: 'Select a date',
      startTime: 'Start Time',
      endTime: 'End Time',
      selectTime: 'Set time',
      timesError: 'Set both times or neither',
      location: 'Location',
      selectLocation: 'Select a location',
      venue: 'Place, venue or hotel name',
      venuePlaceholder: 'e.g. Convention Center',
      website: 'Website',
      websitePlaceholder: 'https://yourwebsite.com',
      websiteError: 'Website URL must start with https://',
      details: 'Event Details',
      detailsPlaceholder: 'Describe the event...',
      organizer: "I'm the host/organizer",
      save: 'Save Changes',
      create: 'Create Event',
      required: 'Required',
    },
    addToCalendar: 'Add to Calendar',
    share: {
      title: 'Check out this event',
      message: 'Check out {{eventName}}',
      shareEvent: 'Share event',
    },
  },
  post: {
    like_one: '{{count}} like',
    like_other: '{{count}} likes',
    comment_one: '{{count}} comment',
    comment_other: '{{count}} comments',
    addComment: 'Comment',
    announcement: 'Announcement',
    singlePost: 'Post',
    newPost: 'New Post',
    placeholder: "What's on your mind?",
    compose: {
      wallPlaceholder: "Write on {{userName}}'s wall...",
    },
    publish: 'Publish',
    createSuccess: 'Your post has been published',
    createError: 'Failed to publish post',
    editSuccess: 'Your post has been updated',
    editError: 'Failed to update post',
    readMore: 'Read More',
    featuredPhoto: {
      warningWithReset:
        "It appears you posted another photo very recently, which means this photo won't be featured in the global newsfeed, unless you wait {{minutes}} minutes to post it",
    },
    menu: {
      edit: 'Edit post',
      dismissAnnouncement: 'Hide announcement',
      share: 'Share post',
      stopNotifications: 'Disable notifications',
      resumeNotifications: 'Resume notifications',
      report: 'Report post',
      delete: 'Delete post',
    },
    mute: {
      title: 'Disable notifications for how long?',
      oneHour: '1 hour',
      eightHours: '8 hours',
      oneDay: '24 hours',
      indefinitely: 'Indefinitely',
      success: 'Notifications for this post disabled successfully',
      error: 'Failed to disable notifications for this post',
    },
    unmute: {
      success: 'Notifications for this post resumed successfully',
      error: 'Failed to resume notifications for this post',
    },
    getMutedState: {
      error: 'Failed to get notification status',
    },
    dismissAnnouncement: {
      success: 'Announcement dismissed',
      error: 'Failed to dismiss announcement',
    },
    delete: {
      confirmTitle: 'Delete Post',
      confirmMessage: 'Are you sure you want to delete this post? This action cannot be undone.',
      success: 'Post deleted successfully',
      error: 'Failed to delete post',
    },
    share: {
      title: 'Share Post',
      message: 'Check out this post from {{userName}}',
      success: 'Post shared successfully',
      copied: 'Link copied to clipboard',
      error: 'Failed to share post',
      shareLink: 'Share link',
      copy: 'Copy',
      open: 'Open',
      postUrl: 'Post URL',
    },
  },
  media: {
    gif_button_label: 'Add a GIF',
    no_results: 'No GIFs found',
    failed_to_load: 'Unable to load GIF',
    search_placeholder: 'Search {{provider}}',
    powered_by: 'Powered by {{provider}}',
  },
  comments: {
    title: 'Comments',
    titleOnItem: 'Comments on {{itemType}} from {{userName}}',
    empty: 'Be the first to comment!',
    add_placeholder: 'Add a comment...',
    added: 'Your comment has been published',
    add_error: 'Failed to publish comment',
    editSuccess: 'Your comment has been updated',
    editError: 'Failed to update comment',
    menu: {
      edit: 'Edit comment',
      report: 'Report comment',
      delete: 'Delete comment',
    },
    delete: {
      confirmTitle: 'Delete Comment',
      confirmMessage: 'Are you sure you want to delete this comment? This action cannot be undone.',
      success: 'Comment deleted successfully',
      error: 'Failed to delete comment',
    },
    viewMore_one: 'View {{count}} more comment',
    viewMore_other: 'View {{count}} more comments',
  },
  likes: {
    title: 'Likes',
    titleOnItem: 'Likes on {{itemType}} from {{userName}}',
  },
  notifications: {
    title: 'Notifications',
    titleNative: 'Push notifications',
    empty: 'No notifications yet',
    newNotifications: 'New notifications',
    clearAll: 'Clear all',
    clearAllConfirmTitle: 'Clear notifications',
    clearAllConfirmMessage:
      'This will dismiss all notifications, including pending private photo access requests. Continue?',
    clearAllSuccess: 'Notifications cleared',
    clearAllError: 'Failed to clear notifications',
    dismiss: 'Dismiss notification',
    dismissSuccess: 'Notification dismissed',
    dismissError: 'Failed to dismiss notification',
    andOthers_one: '(and {{count}} other)',
    andOthers_other: '(and {{count}} others)',
    unlockAcceptSuccess: 'Unlock request accepted',
    unlockAcceptError: 'Failed to accept unlock request',
    unlockRejectSuccess: 'Unlock request rejected',
    unlockRejectError: 'Failed to reject unlock request',
    permissionDisabledTitle: 'Push notifications are disabled',
    permissionDisabledDescription:
      "Enable notifications in settings so you don't miss new activity.",
    openSettings: 'Open settings',
  },
  settings: {
    title: 'Settings',
    appearance: 'Appearance',
    location: {
      title: 'Location',
      current: 'Published as',
      mode: 'Place name',
      fixed: 'Fixed',
      automatic: 'Automatic',
      enable: 'Enable location...',

      enableHelp: 'Enable Location',
      enableHelpBlocked: 'Your browser is currently blocking access to your location',
      enableHelpSteps:
        'To enable it, follow the steps below:\n\n\u2022 Open the site information menu near the address bar (lock or settings or info icon).\n\u2022 Find Permissions for this site and locate the Location setting.\n\u2022 Change Location to Allow (or Ask each time).\n\u2022 Reload the page.',
      tips: 'Tips and Privacy',
      fixedSet: 'Published location updated',
      fixedError: 'Unable to set location',
      searchPlaceholder: 'City, postal code or address',
      searchHint: 'Type at least 2 characters',
      noResults: 'No matching places. Check the spelling or try a nearby city.',
      searchError: 'Place search failed',
      pickPlace: 'Choose a place',
      autoDescription:
        'The place name (city) that appears on your profile will be updated as you travel',
    },
    account: {
      title: 'Account',
      username: {
        title: 'Change username',
        title_short: 'Username',
        label: 'New username',
        placeholder: 'Enter new username',
        helper:
          'Choose a new username between 2 and 20 characters that starts with a letter. Only letters, digits, - and _ are allowed.',
        invalid: 'Invalid username',
        unavailable: 'This username is already taken',
        current: 'Username:',
        updateAndSignOut: 'Update and sign out',
        successSignOut: 'Username updated. Please sign back in with your new username.',
        error: 'Failed to update username',
      },
      email: {
        title: 'Change email',
        title_short: 'Email',
        label: 'New email',
        placeholder: 'Enter new email address',
        changeExplanation:
          'We will email a confirmation link to your new address. Your email will update after you confirm.',
        invalid: 'Enter a valid email address',
        unavailable: 'This email is already in use',
        current: 'Email:',
        success: 'Email change requested. Check your inbox to confirm.',
        error: 'Failed to update email',
      },
      password: {
        title: 'Change password',
        change: 'Change password',
        old: 'Current password',
        new: 'New password (min 6 characters)',
        repeat: 'Repeat new password',
        mismatch: "Passwords don't match",
        oldRequired: 'Enter your current password',
        success: 'Password updated',
        error: 'Failed to update password',
      },
      delete: {
        title: 'Delete account',
        confirmLabel: 'Confirm with your current password',
        confirmMessage: 'This action is permanent. Type your current password to confirm.',
        placeholder: 'Enter current password',
        submit: 'Delete my account',
        required: 'Enter your current password',
        success: 'Your account has been deleted',
        error: 'Failed to delete account',
      },
    },
    privacy: {
      title: 'Privacy and Safety',
      blockedMembers: 'Blocked members',
      photoUnlockAuthorized: 'Private photos authorizations',
      emptyHelp: {
        blocked: 'Blocked members will appear here. You can remove blocks any time.',
        photoUnlockAuthorized:
          "Members you've allowed to view your private photos will appear here. You can revoke access at any time.",
      },
      removeUnlock: {
        title: 'Remove access',
        action: 'Remove access',
        confirmMessage: 'Remove access to your private photos for {{userName}}?',
        success: 'Access removed',
        error: 'Failed to remove access',
      },
    },
    language: 'Language',
    system: 'Same as system',
    community: 'Community',
    pattern: 'Header pattern',
    patterns: {
      none: 'None',
      bones: 'Bones & paws',
      circles: 'Circles',
      food: 'Food',

      japanese: 'Japanese',
      plaid: 'Plaid',
      polygonal: 'Polygonal',
      sprinkles: 'Sprinkles',
      stars: 'Stars',
      triangles: 'Triangles',
    },
    appIcon: {
      title: 'App Icon',
      description: 'Choose the icon that appears on your home screen.',
      changed: 'App icon updated',
    },
    theme: {
      title: 'Theme',
      auto: 'Same as system',
      light: 'Light mode',
      dark: 'Dark mode',
    },
    units: {
      title: 'Units',
      distance: 'Distance',
      distanceKm: 'Kilometers (km)',
      distanceMi: 'Miles (mi)',
      height: 'Height',
      heightM: 'Meters (m)',
      heightFt: 'Feet (ft)',
      weightUnit: 'Weight',
    },
    diagnostics: {
      title: 'Diagnostics Tools',
      signalr: 'SignalR Diagnostics',
      clearCache: 'Clear cache',
      cacheCleared: 'Cache cleared successfully',
    },
    preferences: {
      title: 'Preferences',
      birthdayList: 'Birthday list',
      birthdayListDescription: 'Show me in the birthday list',
      anonymousViewing: 'Anonymous viewing',
      anonymousViewingDescription: 'Browse profiles without appearing in visitors list',
      inboundMessagePhotos: 'Inbound photos',
      inboundMessagePhotosDescription:
        'Allow photos in DMs from anyone (otherwise only from people you follow)',
      emailNotifications: 'Email notifications',
      emailNotificationsDescription: 'Receive emails for new messages',
      photosInNewsfeed: 'Photos in newsfeed',
      photosInNewsfeedDescription: 'Show posts with photos in global newsfeed',
      mediaInComments: 'Show GIFs in comments',
      mediaInCommentsDescription:
        'Show GIFs and other media in comments on posts and photos.',
      safeModeOff: 'Sensitive and unreviewed media',
      safeModeOffDescription: 'Display media that may contain sensitive content (NSFW)',
    },
    safety: {
      title: 'Safety options',
    },
    notifications: {
      title: 'Notifications',
      titleWithSounds: 'Notifications & Sounds',
      description: 'Choose which activities trigger push notifications',
      futureNotifications:
        'The following push notifications are planned for future implementation and are not currently active.',
      newMessage: 'New messages',
      newMessageDescription: 'When someone sends you a message',
      newFollower: 'New followers',
      newFollowerDescription: 'When someone follows you',
      newPhotoComment: 'Photo comments',
      newPhotoCommentDescription: 'When someone comments on your photos',
      newPostComment: 'Post comments',
      newPostCommentDescription: 'When someone comments on your posts',
      newWallPost: 'Wall posts',
      newWallPostDescription: 'When someone posts on your wall',
      web: {
        mobileTitle: 'Push notifications are not available on the web',
        mobileSubtitle:
          'Install the iOS or Android app to get push notifications when someone messages you or interacts with your content.',
        soundsDescription:
          'Pick a chime to play when something new arrives. Sounds are played by your browser, so keep the {{communityName}} tab open.',
        messageSoundLabel: 'New message sound',
        notificationSoundLabel: 'New notification sound',
        preview: 'Preview sound',
        appStoreButton: 'Get it on the App Store',
        googlePlayButton: 'Get it on Google Play',
      },
      sounds: {
        off: 'Off',
        trill: 'Trill',
        stepUp: 'Step up',
        bubblePop: 'Bubble pop',
        marimba: 'Marimba',
        metro: 'Metro',
        retro: 'Retro',
        sparkle: 'Sparkle',
        strings: 'Strings',
      },
    },
    dangerZone: 'Danger zone',
    about: {
      title: 'About this app',
      version: 'Version',
      build: 'build',
      madeWithCities: 'Made with ❤️ in Montreal, New York and San Francisco',
      whatsNew: "What's new in this release",
    },
  },
  whatsNew: {
    title: "What's New",
    currentReleaseTitle: 'In this release',
    catchUpReleaseTitle: 'Since last update',
    recentUpdatesTitle: 'Recent updates',
    lineageLabel: 'Version {{lineage}}',
    empty: 'No updates to show.',
    neverShowAgain: 'Never show again',
    showOnNewVersions: 'Show this sheet on new versions',
  },
  upgrade: {
    prompt: 'Get full-size photos in your feed with no daily cap',
    upgrade_button: 'Get Premium',
  },
  premium: {
    upgradeCard: {
      photos: '...and many more! Upgrade to {{premiumPlan}} to see all photos.',
      members: '...and many more! Upgrade to {{premiumPlan}} to see all members.',
      conversation: 'Upgrade to {{premiumPlan}} to access your full conversation history.',
    },
  },
  paywall: {
    ViewFullsizePhoto:
      'Current limit reached for viewing full-size photos. Upgrade to {{premiumPlanName}} for unlimited access.',
    OutgoingCommunication:
      'Current limit reached for sending messages and wall posts. Upgrade to {{premiumPlanName}} for unlimited communication.',
    NewsfeedSearch:
      'Current limit reached for newsfeed searches. Upgrade to {{premiumPlanName}} for unlimited searches.',
    ValidateGiftCertificate: 'Current limit reached for gift certificate validations.',
    Blocks:
      'You have reached the maximum number of blocked members. Upgrade to {{premiumPlanName}} for more blocks.',
    BlockingAMember:
      'You recently blocked or unblocked this member. Please wait 3 days before blocking or unblocking them again.',
    PostsPerHour: 'You have reached your hourly posting limit. Please wait before posting again.',
    ChangeOfEmail: 'Current limit reached for email change requests. Please try again tomorrow.',
    PhotoStream:
      'Current limit reached for viewing photo streams. Upgrade to {{premiumPlanName}} for unlimited access.',
    AnonymousViewing:
      'Anonymous viewing requires a {{premiumPlanName}} membership. Upgrade to browse profiles without appearing in visitors lists.',
    FeaturedPhotos:
      'You can only feature one photo in the global newsfeed per hour. Please wait before posting another.',
    PhotoUnlockRequests:
      'Current limit reached for photo unlock requests. Upgrade to {{premiumPlanName}} for unlimited requests.',
    PostsPerDay: 'You have reached your daily posting limit. Please try again tomorrow.',
    UploadedPhotos:
      'You have reached your photos limit. Upgrade to {{premiumPlanName}} to upload more photos.',
    UploadedPhotosPerDay:
      'You have reached your daily photo upload limit. Upgrade to {{premiumPlanName}} to upload more photos today.',
    MemberSearch:
      "You've reached the daily search limit. Upgrade to {{premiumPlanName}} for unlimited searches.",
    MyTypeFilterChange:
      "You've reached the daily limit for changing your type filter. Upgrade to {{premiumPlanName}} to change it anytime.",
    default: 'This feature requires a {{premiumPlanName}} account. Upgrade to continue.',
    resetIn: {
      minutes_one: 'Try again in {{count}} minute',
      minutes_other: 'Try again in {{count}} minutes',
      hours_one: 'Try again in {{count}} hour',
      hours_other: 'Try again in {{count}} hours',
    },
  },
  notFound: {
    title: "Sorry, we can't find what you're looking for.",
    goHome: 'Back to home screen',
  },
  communitiesHeader: {
    title: 'Communities',
  },
  profile: {
    aboutMe: 'About Me',
    stats: 'Stats',
    bio: 'Bio',
    height: 'Height',
    weight: 'Weight',
    gender: 'Gender',
    origin: 'Origin',
    relationship: 'Relationship',
    languages: 'Languages',
    interestedIn: 'Interested In',
    preferences: 'Preferences',
    lookingFor: 'Looking For',
    bodyTypesLiked: 'Body Types',
    bodyPartsLiked: 'Body Features',
    sexualInterests: 'Sexual Interests',
    mutualKinks: 'Mutual Kinks',
    // Shared field labels (used by search, profile view, and edit profile)
    identifyAs: 'Identifies as',
    relationshipStatus: 'Relationship status',
    bodyTypes: 'Body types',
    bodyHair: 'Body hair',
    facialHair: 'Facial hair',
    communityKinks: 'Community kinks',
    otherKinks: 'Other kinks',
    // Section titles
    sections: {
      identity: 'Identity & Background',
      interestsAndKinks: 'Interests and kinks',
      bodyFeatures: 'Body types and features',
    },
    // Units
    units: {
      weight: {
        pounds: 'Pounds (lb)',
        kilograms: 'Kilograms (kg)',
        stones: 'Stones (st)',
        short: {
          lb: 'lb',
          kg: 'kg',
          st: 'st',
        },
        suffix: {
          lbs: 'lbs',
          kg: 'kg',
          st: 'st',
        },
      },
      height: {
        feet: 'Feet (ft)',
        meters: 'Meters (m)',
        short: {
          ft: 'ft',
          m: 'm',
        },
        suffix: {
          m: 'm',
        },
      },
    },
    lastSeen: 'Last seen',
    lastVisitedYou: 'Last Visited You',
    notYet: 'Not yet',
    activity: 'Activity',
    joinDateWithCommunity: 'On {{communityName}} Since',
    seeAllPhotos: 'See all',
    followers_one: 'follower',
    followers_other: 'followers',
    following_one: 'following',
    following_other: 'following',
    follows_you: 'Follows you',
    followersCount_one: '{{count}} follower',
    followersCount_other: '{{count}} followers',
    followingCount: '{{count}} following',
    followersOfUser: 'Followers of {{userName}}',
    followingOfUser: '{{userName}} is following',
    tabs: {
      about: 'About',
      posts: 'Posts',
      photos: 'Photos',
      events: 'Events',
      weight: 'Weight',
      wall: 'Wall',
    },
    photos: {
      public: 'Public',
      private: 'Private',
      privateLocked: 'Private photos are locked',
      requestAccess: 'Request access',
      extendedPreviewNotice: 'More photos are visible to you because this member is on {{premiumPlan}}.',
      requestPending: 'Your request to access private photos is pending approval',
      requestSubmitted: 'Access request sent',
      requestFailed: 'Failed to send access request',
    },
    wall: {
      empty: 'No posts to show',
    },
    share: {
      title: 'Share Profile',
      message: "Check out {{userName}}'s profile",
      shareProfile: 'Share profile',
    },
  },
  member: {
    notFound: 'Member not found',
    menu: {
      report: 'Report member',
      block: 'Block member',
      unblock: 'Unblock member',
      privatePhotosSection: 'Private photos',
      revokePrivatePhotos: {
        action: 'Revoke their access',
        confirmTitle: 'Revoke access',
        confirmMessage:
          '{{userName}} will no longer be able to see your private photos. They can send you a new request later.',
        success: 'Access revoked',
        error: 'Failed to revoke access',
      },
      forfeitPrivatePhotos: {
        action: 'Unsubscribe',
        confirmTitle: 'Unsubscribe',
        confirmMessage:
          "You'll no longer be able to see {{userName}}'s private photos. You can request access again later.",
        success: 'Unsubscribed',
        error: 'Failed to unsubscribe',
      },
    },
    block: {
      confirmMessage:
        'Are you sure you want to block {{userName}}? This action cannot be undone for the next 72 hours to prevent harassment.',
      success: 'Member blocked successfully',
      error: 'Failed to block member',
    },
    unblock: {
      confirmMessage:
        'Are you sure you want to unblock {{userName}}? This action cannot be undone for the next 72 hours to prevent harassment.',
      success: 'Member unblocked successfully',
      error: 'Failed to unblock member',
    },
    unfollow: {
      confirmTitle: 'Unfollow',
      confirmMessage: 'Are you sure you want to unfollow {{userName}}?',
      success: 'You are no longer following {{userName}}',
      error: 'Failed to unfollow member',
    },
    follow: {
      success: 'You are now following {{userName}}',
      error: 'Failed to follow member',
    },
    locked: {
      message: 'Upgrade to {{premiumPlan}} to browse unlimited member profiles.',
    },
  },
  userMenu: {
    viewProfile: 'View my profile',
    editProfile: 'Edit my profile',
    settings: 'Settings',
    plans: 'Plans & Subscription',
    help: 'Help & Support',
    feedback: 'New Platform Feedback',
    rules: 'Community Rules',
    browseCommunities: 'Browse communities',
    signOut: 'Sign Out',
  },
  editProfile: {
    title: 'Edit Profile',
    saveSuccess: 'Profile updated successfully',
    saveError: 'Failed to update profile',
    loadError: 'Failed to load profile',
    saving: 'Saving...',
    sections: {
      basicInfo: 'Basic Info',
    },
    firstName: 'First Name',
    firstNamePlaceholder: 'Enter your first name',
    birthDate: 'Birth Date',
    selectYear: 'Select Year',
    selectMonth: 'Select Month',
    selectDay: 'Select Day',
    selectHeight: 'Select Height',
    weightGoal: 'Weight Goal',
    weightRangeError: 'Weight must be within the allowed range',
    descriptionPlaceholder: 'Tell us about yourself...',
    textPlaceholder: 'Enter text...',
    notSet: 'Not set',
    identifyAs: 'I identify as',
    myBodyType: 'My body type',
    bodyTypesLiked: 'Body types I like',
    bodyPartsLiked: 'Body features I like',
    myBodyHair: 'My body hair',
    myFacialHair: 'My facial hair',
    hints: {
      firstName: 'Optional. Appears on your profile after your username.',
      birthDate:
        'Not visible to other users. Used to verify you are an adult and display your age.',
      bio: 'Tell others about yourself, what you like, and what you are looking for.',
    },
  },
  account: {
    plans: {
      title: 'Plans & Subscription',
      includedWith: "What's included with {{planName}}",
      choosePlan: 'Choose your plan',
      terms: 'Terms',
      bestValue: 'BEST VALUE',
      monthlyPlan: '{{planName}} Monthly Plan',
      yearlyPlan: '{{planName}} Yearly Plan',
      regularPrice: 'Regular price',
      perMonth: 'per month',
      perYear: 'per year',
      onlyPerMonth: 'Only {{price}}/month (save {{percent}}%)',
      pricesIn: 'Prices in {{currency}}.',
      billingTerms_ios:
        "Payment will be charged to your Apple account upon confirmation of purchase. Plans are valid for the term you select and will automatically renew at the price listed unless canceled at least 24 hours before the end of the current period. You can cancel your subscription anytime by going in your device's settings or by using Manage Subscription above.",
      billingTerms_android:
        "Payment will be charged to your Google account upon confirmation of purchase. Plans are valid for the term you select and will automatically renew at the price listed unless canceled at least 24 hours before the end of the current period. You can cancel your subscription anytime by going in your device's settings or by using Manage Subscription above.",
      billingTerms_web:
        'Subscription terms and billing details will be provided upon checkout. Your subscription will automatically renew unless canceled before the renewal date.',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      manageSubscription: 'Manage Subscriptions',
      currentPlan: 'Current Plan',
      loading: 'Loading plans...',
      confirming: 'Confirming your subscription...',
      connecting: 'Connecting to store...',
      connectionError: 'Connection Error',
      openPlayStore: 'Open Play Store',
      signInToPlayStore: 'Sign in to Google Play Store to continue',
      openAppStore: 'Open App Store',
      checkAppStoreConnection: 'Check your App Store connection and try again',
      premiumFeatures: {
        unlimitedPhotos: 'Unlimited photo viewing',
        featureMorePhotosToRegularMembers: 'Feature more of your photos to regular members',
        unlimitedMessaging: 'Unlimited messaging',
        moreBlocks: 'More blocks',
        morePhotoUploads: 'More photo uploads',
      },
      learnMoreAboutPlans: 'Learn all about our plans',
      yourAccountIsOn: 'Your account is on the {{planName}} plan',
      currentCreditsUntil: 'Current credits running until:',
      daysLeft_one: '{{count}} day left',
      daysLeft_other: '{{count}} days left',
      hoursLeft_one: '{{count}} hour left',
      hoursLeft_other: '{{count}} hours left',
      subscriptionRenewalNote:
        'Your subscription renews automatically based on your billing cycle. Each renewal adds credits to your account. Credits from promotions or gift certificates can extend beyond your current subscription period. Thank you for being a {{planName}} member!',
      billingNotAvailable: 'Subscriptions are not currently available',
      grandfatheredPricing: "Congrats! You've been grandfathered-in to our previous lower prices.",
      oneMonth: 'Monthly',
      threeMonths: 'Quarterly',
      oneYear: 'Yearly',
      oneYearCombo: 'Yearly Duo',
      comboSubtitle: 'Includes Grommr XL and 1 year of Chasable+ (gift certificate)',
      every3Months: 'every 3 months',
      save: 'save {{percent}}%',
      renewsEveryDays: 'Automatically renews every {{days}} days',
      subscribe: 'Subscribe',
      subscribed: 'Subscribed',
      manageCCBill: 'Cancel/manage a CCBill subscription',
      subscriptionIdLabel: 'Your most recent CCBill subscription ID',
      subscriptionIdCopied: 'Subscription ID copied to clipboard',
      ccbillPayments: 'CCBill Payments (Subscriptions)',
      ccbillDescription:
        'We use CCBill to handle our billing and there are a variety of ways you can purchase your pass by credit card: We accept Visa, Mastercard, JCP & Discover. Your credit card statement will show "CCBill.Com *Grokio" (Grokio Communities LLC is the operating company behind {{communityName}}). You have the option of conducting your transaction in one of five currencies: USD; EUR; GBP; CAD; AUD; and JPY. As soon as we receive confirmation that the payment was made, the new time will be added to your account (in most cases this should be immediate). All subscriptions via CCBill automatically renew. If you wish to cancel your subscription you can use the provided link and cancel it at least 48 hours before it renews.',
      billingFaq: 'Billing Information & FAQ',
      billingFaqDescription:
        'Check out our {{planName}} Billing Information document for details about payments, renewals and cancellations.',
      billingFaqGuide: 'Guide to {{planName}}',
      getBillingSupport: 'Get Billing Support',
      restorePurchases: 'Restore Purchases',
      error: {
        loadProducts: 'Failed to load subscription plans',
        noProductsFound: 'No subscription products found',
        purchase: 'Purchase failed',
        purchasePayment:
          'Your purchase could not be completed. Please check your payment method and try again.',
        purchaseNetwork:
          'Unable to connect to the store. Please check your internet connection and try again.',
        purchaseUnavailable: 'In-app purchases are not available on this device or account.',
        purchaseAlreadyOwned: 'You already have an active subscription for this plan.',
        purchaseDeferred:
          'Your payment is pending approval. The subscription will activate once approved.',
        purchaseItemUnavailable: 'This subscription plan is not currently available.',
        validation: 'Failed to validate purchase',
        restore: "Couldn't restore — try again or contact support",
        restoreUnavailable: 'Unable to reach the store. Please check your connection and try again.',
      },
      success: {
        subscribedWithPlan: 'Thank you for subscribing! Your {{planName}} plan is now active.',
        subscribedWithBogo:
          'Thank you for subscribing! Your {{planName}} is now active. Bonus: You earned an extra {{period}} with our promotion!',
        restored: 'Purchases restored successfully',
        nothingToRestore: 'No purchases to restore',
      },
    },
    transactions: {
      title: 'Transactions History',
      empty: 'No transactions yet',
      days_one: 'day',
      days_other: 'days',
      header: {
        date: 'Date',
        description: 'Description',
      },
    },
    certificates: {
      title: 'Gift Certificates',
      history: 'Your gift certificates',
      empty: 'No gift certificates yet',
      purchase: 'Gift Certificate Purchase',
      redeemed: 'Gift Certificate Redeemed',
      redeemedOn: 'Redeemed on {{date}}',
      codeCopied: 'Certificate code copied to clipboard',
      redeem: {
        title: 'Redeem a gift certificate',
        helper: 'Enter the code you received to add premium time to your account.',
        placeholder: 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX',
        button: 'Redeem',
        success_one: 'Gift certificate redeemed! {{count}} day was added to your account.',
        success_other: 'Gift certificate redeemed! {{count}} days were added to your account.',
        invalidFormat: "This doesn't look like a gift certificate code. Codes have 25 letters and numbers.",
        notFound: "We couldn't find this code. Make sure you're redeeming it in the community it was issued for.",
        alreadyRedeemed: 'This gift certificate has already been redeemed.',
        tooManyAttempts: 'Too many attempts. Try again tomorrow.',
        error: "We couldn't redeem this gift certificate. Try again later.",
      },
      header: {
        date: 'Date',
        details: 'Details',
      },
    },
  },
  webDrop: {
    dropToUpload: 'Drop image to upload',
    dragHint: 'Drag a JPG/PNG image here',
  },
  weightHistory: {
    stats: 'Stats',
    currentWeight: 'Current',
    trend: 'Trend',
    bmi: 'BMI',
    goal: 'Goal',
    perMonth: '/mo',
    history: 'History',
    date: 'Date',
    weight: 'Weight',
    notes: 'Notes',
    noData: 'No weight records yet',
    noChartData: 'Not enough data for chart',
    addRecord: 'Add',
    editRecord: 'Edit weight',
    selectDate: 'Select date',
    notesPlaceholder: 'Optional notes...',
    added: 'Weight added',
    updated: 'Weight updated',
    deleted: 'Weight record deleted',
    saveFailed: 'Failed to save',
    deleteFailed: 'Failed to delete record',
    deleteTitle: 'Delete',
    deleteConfirm: 'Delete this weight record?',
  },
  footer: {
    support: 'Support',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
  },
  report: {
    reasonTitle: 'Why are you reporting this?',
    rulesLink: 'Read the Community Rules',
    reasons: {
      scam: 'Scammer',
      spam: 'Spamming',
      falsePortrayal: 'False Portrayal',
      harassment: 'Harassment',
      intolerance: 'Intolerance',
      trolling: 'Trolling',
      disparagement: 'Disparagement',
      donationRequest: 'Donation Request',
      promotionalPosting: 'Promotional Posting Violation',
      photoPolicy: 'Photo Policy Violation',
      uncreditedArtwork: 'Uncredited Artwork',
      underage: 'Underage',
      illegalActivity: 'Other Illegal Activities',
      other: 'Other',
    },
  },
};
